/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Resource } from '../../models/resource';

export interface GetExcel$Params {

/**
 * The id (i.e path/name) of imported excel file to get the reference
 */
  key: string;
}

export function getExcel(http: HttpClient, rootUrl: string, params: GetExcel$Params, context?: HttpContext): Observable<StrictHttpResponse<Resource>> {
  const rb = new RequestBuilder(rootUrl, getExcel.PATH, 'get');
  if (params) {
    rb.path('key', params.key, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Resource>;
    })
  );
}

getExcel.PATH = '/import/excels/{key}';
